window.tscUserRepository = {};
window.tscUserRepository.create = function (global, doc, loc, $) {
  'use strict';

  var repo = sessionStorage || {
    getItem: $.noop(),
    setItem: $.noop(),
    removeItem: $.noop()
  };

  var profileJSON = repo.getItem('tscProfile');
  var sessionProfile = profileJSON ? JSON.parse(profileJSON) : {};

  var getStatus = $.getJSON('/api/v/1/profile/status/');
  var pendingStatus = true;
  var profileDeferred = $.Deferred();

  var normalizeApiData = function (data) {
    data = data || {};
    if ('SignedIn' in data) {
      return !data.SignedIn ? null : {
        tscId: data.Profile.TechSmithId,
        displayName: data.Profile.DisplayName,
        email: data.Profile.Email
      };
    }
    return !('techSmithId' in data) ? null : {
      tscId: data.techSmithId,
      displayName: data.displayName,
      email: data.email,
      profileImageUrl: data.profileImageUrl,
      firstName: data.firstName,
      lastName: data.lastName,
      hashedEmail: data.hashedEmail,
      hashedFirstName: data.hashedFirstName,
      hashedLastName: data.hashedLastName
    };
  };

  var tryGetAuth0Client = function () {
    var deferred = $.Deferred();

    try {
      var client = new global.auth0.Auth0Client({
        domain: window.tscAuth.Authenticate.domain,
        clientId: window.tscAuth.Authenticate.clientId,
        authorizationParams: {
          audience: 'https://apis.techsmith.com',
          redirect_uri: loc.origin + '/callback'
        }
      });

      deferred.resolve(client);
    } catch (error) {
      deferred.reject();
    }

    return deferred.promise();
  };

  var getTokenSilently = function (client) {
    return client.getTokenSilently({
      detailedResponse: true,
      authorizationParams: {
        timeoutInSeconds: 30
      }
    });
  };

  var postToSigninSilently = function (token) {
    return $.post({
      url: '/api/v/1/profile/auth/',
      headers: {
        Authorization: ['Bearer', token.access_token].join(' ')
      },
      data: { idToken: token.id_token }
    });
  };

  var updateWithSilentSignin = function (result) {
    var resultProfile = normalizeApiData(result);
    sendProfileUpdate(resultProfile);
    profileDeferred.resolve(resultProfile);
  };

  var trySigningInSilently = function () {
    tryGetAuth0Client()
      .then(getTokenSilently)
      .then(postToSigninSilently)
      .then(updateWithSilentSignin)
      .catch(function () {
        profileDeferred.resolve(null);
      });
  };

  getStatus.then(function (status) {
    var statusProfile = normalizeApiData(status);

    if (statusProfile && statusProfile.tscId === sessionProfile.tscId) {
      pendingStatus = false;
      sendProfileUpdate(sessionProfile);
      profileDeferred.resolve(sessionProfile);
      return;
    }

    sendProfileUpdate(statusProfile);

    if (statusProfile) {
      $.getJSON('/api/v/1/profile/info/').then(function (info) {
        var infoProfile = normalizeApiData(info);
        pendingStatus = false;
        sendProfileUpdate(infoProfile);
        if (!infoProfile) {
          trySigningInSilently();
        } else {
          profileDeferred.resolve(infoProfile);
        }
      });
    } else {
      pendingStatus = false;
      trySigningInSilently();
    }
  });

  var updateCallbacks = [];

  var setupCallback = function (callback, property) {
    var isForSpecificProperty = property && property !== 'statusOnly';
    var alwaysUpdate = property === 'statusOnly';

    var signedOut = function (data) {
      return !data;
    };

    var isFullProfile = function (data) {
      return 'profileImageUrl' in data;
    };

    var sendUpdate = function (data) {
      if (signedOut(data)) {
        callback(isForSpecificProperty ? '' : null);
      } else if (isFullProfile(data)) {
        callback(isForSpecificProperty ? data[property] : data);
      } else if (alwaysUpdate) {
        callback(data);
      }
    };

    updateCallbacks.push(sendUpdate);
    if (!pendingStatus) {
      sendUpdate(sessionProfile.tscId ? sessionProfile : null);
    }
  };

  var sendProfileUpdate = function (normalizedProfile) {
    if (normalizedProfile) {
      sessionProfile = normalizedProfile;
      repo.setItem('tscProfile', JSON.stringify(normalizedProfile));
    } else {
      sessionProfile = {};
      repo.removeItem('tscProfile');
    }
    updateCallbacks.forEach(function(callback) {
      callback(normalizedProfile);
    });
  };

  var getStatusUpdates = function (callback) {
    setupCallback(callback, 'statusOnly');
  };

  var publicApi = {
    getProfileUpdates: function (callback) {
      setupCallback(callback);
    },
    getDisplayNameUpdates: function (callback) {
      setupCallback(callback, 'displayName');
    },
    getEmailUpdates: function (callback) {
      setupCallback(callback, 'email');
    },
    getProfileImageUpdates: function (callback) {
      setupCallback(callback, 'profileImageUrl');
    },
    getProfileAsPromise: function () {
      return profileDeferred.promise();
    },
    getSignInUrl: function (username) {
      var uParam = username ? '&u=' + encodeURIComponent(username) : '';
      return '/signin?p=' + encodeURIComponent(loc.pathname + loc.search + loc.hash) + uParam;
    },
    getSignOutUrl: function () {
      return '/signout?p=' + encodeURIComponent(loc.pathname + loc.search + loc.hash);
    }
  };

  // jQuery ready event handler
  $(function () {

    getStatusUpdates(function (profile) {
      if (!profile) { return; }

      $('.profile').addClass('is-auth').removeClass('no-auth');
      $('.tsc-header-wrapper').addClass('user-is-auth');
      $('.mobile-nav-item').removeClass('hide');

      var $signInStatus = $('.sign-in-status');
      $signInStatus.text($signInStatus.data('sign-out-text') + ' ' + profile.displayName);
      $('#displayName').text(profile.displayName);
      $('#displayEmail').text(profile.email);
    });

    var signedInUpdate = function (profile) {
      var $iconImage = $('#profileIconImageUrl');

      $iconImage.on('load', function() {
        $iconImage.parent().addClass('loaded');
      }).add('#profileImageUrl').attr('src', profile.profileImageUrl);
    };

    var signedOutUpdate = function () {
      var $signInStatus = $('.sign-in-status');
      $signInStatus.text($signInStatus.data('sign-in-text'));
      $('#displayName').text('');
      $('#displayEmail').text('');
      $('#profileImageUrl, #profileIconImageUrl').attr('src', '');
      $('.mobile-nav-item').addClass('hide');
      $('.profile').removeClass('is-auth').addClass('no-auth');
      $('.tsc-header-wrapper').removeClass('user-is-auth');
    };

    publicApi.getProfileUpdates(function (profile) {
      if (profile) {
        signedInUpdate(profile);
      } else {
        signedOutUpdate();
      }
    });

    // menus triggers for the supplemental-buttons section of the header
    $('.tsc-dropdown-menu-trigger').click(function (e) {

      //allow href in mobile link
      if ( $('.mobile-menu-active').length > 0 && $(this).hasClass('fs-cart-link')) {
        return;
      }

      e.preventDefault();

      var $parent = $(this).parent();
      if ($parent.hasClass('no-auth')) {
        loc.href = publicApi.getSignInUrl();
        return;
      }

      if ($parent.hasClass('is-auth') && !$('.sign-in-status').is(':hidden') ) {
        loc.href = publicApi.getSignOutUrl();
        return;
      }

      $parent.toggleClass('active').siblings().removeClass('active');
      if ( !$(this).hasClass('fs-cart-link')) {
          $('.mini-cart-position').addClass('mini-cart-hide');
      }
    });

    $('.profile-dropdown-trigger').click(function (e) {
      var $trigger = $(this);
      if ($trigger.parent().hasClass('is-auth')) {
        $trigger.parent().toggleClass('active');
        e.preventDefault();
      } else {
        $trigger.attr('href', publicApi.getSignInUrl());
      }
    });

    $('.mobile-cart-link, .fs-cart-link').click(function () {
      $('.mini-cart-position').toggleClass('mini-cart-hide');
    });

    $(doc).on('touchstart click', function (e) {
      if ($(e.target).closest('.tsc-dropdown-menu-wrapper').length === 0) {
        $('.tsc-dropdown-menu-wrapper.active').removeClass('active');
        if ( $(e.target).closest('.mobile-cart-link').length === 0 && $(e.target).closest('.mini-cart').length === 0) {
          $('.mini-cart-position').addClass('mini-cart-hide');
        }
      }
    });

    $('.sign-out-link').attr('href', '/signout').click(function (e) {
      $(this).attr('href', publicApi.getSignOutUrl());
    });

    // get cart items count
    global.cartSummary = function (data) {
      $('.cart-count').text(data.lineItems).parent('.bubble-icon').toggleClass('hide', data.lineItems === 0);
    };
  });

  return publicApi;
};

if (!window.profileTestMode) {
  window.tscUserRepository = window.tscUserRepository.create(window, document, window.location, jQuery);
}
